
import { NgModule } from '@angular/core';
import { MetaService } from '../';

@NgModule({
    imports:        [],
    declarations:   [],
    providers:      [MetaService],
    exports:        []
})

export class MetaServiceModule{

}


// WEBPACK FOOTER //
// ./src/angular-engine/engine/service/meta/module/meta.service.module.ts